import '@styles/common.less';
import '@styles/layout.less';
import './home.less';
import '@common';

import Swiper from 'swiper';
import 'swiper/css';
import 'swiper/css/pagination';

import LazyLoad from 'vanilla-lazyload';
import { Autoplay } from 'swiper/modules';
import anime from 'animejs';

Swiper.use([Autoplay]);

const HOME_POP_UP_DISMISSED_KEY = 'homePopUpDismissed';

const lockPageScroll = () => {
  document.body.style.overflow = 'hidden';
};

const unlockPageScroll = () => {
  document.body.style.overflow = '';
};

const shouldShowHomePopUp = () => {
  return false
  try {
    return localStorage.getItem(HOME_POP_UP_DISMISSED_KEY) !== '1';
  } catch (error) {
    return true;
  }
};

const hideHomePopUpForever = (popUpEl) => {
  popUpEl.classList.add('hidden');
  popUpEl.setAttribute('aria-hidden', 'true');
  unlockPageScroll();
  try {
    localStorage.setItem(HOME_POP_UP_DISMISSED_KEY, '1');
  } catch (error) {
    // Ignore storage errors to avoid blocking core interactions.
  }
};

document.addEventListener('DOMContentLoaded', () => {
  new LazyLoad({
    elements_selector: '.lazy',
    threshold: 300,
  });


  const swiperEl = document.querySelector('.swiper');
  if (swiperEl) {
    new Swiper(swiperEl, {
      loop: true,
      slidesPerView: 'auto',
      // speed: 600,
      autoplay: true,
    });
  }

  const popUpEl = document.querySelector('#home-pop-up');
  if (!popUpEl) return;

  const closeButtonEl = popUpEl.querySelector('.home-pop-up__close');
  if (!closeButtonEl) return;

  if (!shouldShowHomePopUp()) {
    popUpEl.classList.add('hidden');
    popUpEl.setAttribute('aria-hidden', 'true');
    unlockPageScroll();
    return;
  }

  popUpEl.classList.remove('hidden');
  popUpEl.setAttribute('aria-hidden', 'false');
  lockPageScroll();

  closeButtonEl.addEventListener('click', () => {
    hideHomePopUpForever(popUpEl);
  });
});
